import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
export function isPropsWithChildren(props) {
    return Boolean('children' in props && props.children);
}
export function StateComponent(props) {
    if (isPropsWithChildren(props)) {
        const { children } = props;
        return children;
    }
    const { title, description, actions, icon } = props;
    return (<Box flexDirection="column" alignItems="center" justifyContent="center" gap="md" py="7xl" px="lg">
      {icon}

      {(title || description) && (<Box flexDirection="column" alignItems="center" gap="sm">
          {title && (<Typography $appearance="300" $fontSize="huge" $lineHeight="neutralized" $fontWeight="medium">
              {title}
            </Typography>)}
          {description && (<Typography $appearance="100" $fontSize="small" $lineHeight="neutralized" $fontWeight="regular">
              {description}
            </Typography>)}
        </Box>)}

      {actions && <Box gap="md">{actions}</Box>}
    </Box>);
}
